import AiStarOrangeIcon from "@redotech/redo-icons/ai-star-orange.svg";
import classNames from "classnames";
import { memo } from "react";
import * as styles from "./ask-redo-ai-star-spinner.module.css";

/**
 * Slowly-rotating orange AI star — the brand "agent is working"
 * indicator. Used by the conversation's thinking row and the tool
 * group's in-flight header. Single source of truth for the 1.6s
 * rotation + `prefers-reduced-motion` override.
 *
 * `aria-hidden` by default because the components that host this
 * spinner already carry an accessible label ("Thinking…",
 * "Running list-orders…"). Don't surface another announcement.
 */
export const AskRedoAiStarSpinner = memo(function AskRedoAiStarSpinner({
  className,
}: {
  className?: string;
}) {
  return (
    <AiStarOrangeIcon
      aria-hidden="true"
      className={classNames(styles.spinner, className)}
    />
  );
});
